import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03e2a509"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "login-form" }
const _hoisted_2 = { id: "description" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.moodbuster.science",
  target: "_blank"
}, "www.moodbuster.science", -1))
const _hoisted_4 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", null, _toDisplayString(_ctx.$t("LOGIN.LOGIN")), 1),
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.$t("LOGIN.DESCRIPTION")) + " ", 1),
      _hoisted_3,
      _createTextVNode(". ")
    ]),
    _createElementVNode("form", {
      onSubmit: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.login()), ["prevent"]))
    }, [
      _createElementVNode("button", {
        type: "submit",
        class: "btn primary col-10 login-button",
        disabled: !_ctx.loginButtonEnabled
      }, _toDisplayString(_ctx.$t("LOGIN.LOGIN")), 9, _hoisted_4)
    ], 32)
  ]))
}